import * as Yup from "yup";

export const DeleteSchema = Yup.object().shape({
  id: Yup.string()
  .required("Please select licence type")
});
